import type { EmployeeInfo } from 'src/services/people/types';

import apiClient from '../utils/apiClient';

class PeopleApiService {
  /**
   * get employee info
   */
  public async getEmployeeInfo(login: string) {
    return await apiClient.get<EmployeeInfo>(`employee/login/${login}`);
  }

  public async getEmployeeInfoByPersonId(personId: string) {
    return await apiClient.get<EmployeeInfo>(`employee/personalId/${personId}`);
  }
}

export default new PeopleApiService();
